/** Non-copy constants shared by release promo builders (window keys, element discriminators). */

/** Timestamps in this module use whole seconds (see `Date#getTime() / 1000`). */
export const SECONDS_PER_MINUTE = 60

/** Two hours in seconds — "2 hours before release" warning window start offset. */
export const TWO_HOURS_IN_SECONDS = 2 * 60 * SECONDS_PER_MINUTE

/** Five minutes in seconds — "5 minutes before release" window and 2hr→5m handoff. */
export const FIVE_MINUTES_IN_SECONDS = 5 * SECONDS_PER_MINUTE

export const WARNING_PROMO_WINDOW_2HR = '2hr' as const
export const WARNING_PROMO_WINDOW_5M = '5m' as const

export type WarningPromoWindow = typeof WARNING_PROMO_WINDOW_2HR | typeof WARNING_PROMO_WINDOW_5M

/** PromoDialogTypography / PromoDialogCountdown `type` literals used across success, warning, and progress promos */
export const PROMO_TYPOGRAPHY_TITLE = 'h4' as const
export const PROMO_TYPOGRAPHY_BODY = 'body1' as const
export const PROMO_ELEMENT_COUNTDOWN = 'countdown' as const

export const PROMO_COUNTDOWN_ROUNDING_UP = 'up' as const

export const WARNING_COUNTDOWN_ALERT_SEVERITY = 'info' as const
export const PROGRESS_COUNTDOWN_ALERT_IN_PROGRESS = 'warning' as const
export const PROGRESS_COUNTDOWN_ALERT_COMPLETE = 'success' as const
